import React from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import FAQContainer from "../ComponentUtils/FAQContainer";
import { FAQsArray } from "../../constants";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const col1 = css`
  text-align: center;
`;

function FAQs({ history }) {
  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div className={col + " " + col1} style={{ textAlign: "right" }}>
              <styles.H2
                style={{
                  textAlign: "center",
                  margin: "30px 0px",
                  width: "100%",
                }}
              >
                Frequently Asked Questions<br></br>{" "}
              </styles.H2>
              <FAQContainer
                title={"Frequently Asked Questions"}
                campaigns={FAQsArray}
                isFAQ={true}
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default FAQs;
